export const BASE_URL = 'https://hub.peppercontent.io'
export const API_GATEWAY_BASE_URL = 'https://hub.peppercontent.io'
export const EDITOR_SERVICE_BASE_URL='https://hub.peppercontent.io/pepper-editor-service'
export const USER_SERVICE_BASE_URL = 'https://hub.peppercontent.io/user-service'
export const PAYMENT_SERVICE_BASE_URL = 'https://hub.peppercontent.io/payments-service'
export const SEO_SERVICE_BASE_URL = 'https://hub.peppercontent.io/seo-service'
export const KNOWLEDGE_BASE_BASE_URL = 'https://hub.peppercontent.io/knowledge-base-service'
export const ATLAS_SERVICE_BASE_URL = 'https://hub.peppercontent.io/atlas-service'
export const SPOTDRAFT_URL = 'https://app.qa.dev.spotdraft.com/auth/embed-contract'
export const GET_STREAM_TOKEN = '5g9npp3h462d'
export const CREATE_PROJECT_BASE_URL = 'https://versions.peppercontent.in'
export const REACT_APP_LOOM_API_KEY = '05d592cf-ed8b-4db1-b070-249d24f6c9a6'
export const REACT_APP_UNSPLASH_KEY = '-J2WKws-0lUDfWyqcpC5El8sXM0-agvibTqrlDfteto'
export const SOCKET_URL = 'wss://hub.peppercontent.io'
export const ELASTIC_SERVICE_VERSION = 'prod-920c8062875161a21ab6edd61bcd2b24dc637169'
export const GOOGLE_CLIENT_ID = '799571829246-4f99p0l2a1f8vnqbde18a3scv5m0m5jn.apps.googleusercontent.com'
